import { map } from "rxjs/operators";
import { GET, POST } from "../../module/services/fetch";

export const fetchLoggedUserInfo = () =>
  GET("user/info").pipe(map((response: any) => response));

export const fetchSetLanguage = (language: string) =>
  POST(`user/v1/language?lang=${language}`).pipe(
    map((response: any) => response)
  );
